import { render, staticRenderFns } from "./Landing-FaceAI.vue?vue&type=template&id=72c839c9"
import script from "./Landing-FaceAI.vue?vue&type=script&lang=js"
export * from "./Landing-FaceAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports